
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M10.5858 13.4142C9.02372 11.8521 6.49106 11.8521 4.92897 13.4142C3.36687 14.9763 3.36687 17.509 4.92897 19.0711C6.49106 20.6332 9.02372 20.6332 10.5858 19.0711C12.1479 17.509 12.1479 14.9763 10.5858 13.4142ZM10.5858 13.4142L14.1214 9.8787M19.0711 4.92895L16.9498 7.05027M16.9498 7.05027L19.0711 9.17159M16.9498 7.05027L14.1214 9.8787M14.1214 9.8787L16.2427 12"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiSecretKey",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
